import type { Session } from '@supabase/supabase-js';

/**
 * Check if a user has completed their profile (has a first name)
 * @param session - The current Supabase session
 * @returns boolean - true if profile is complete, false if first name is missing
 */
export function isProfileComplete(session: Session | null): boolean {
    if (!session?.user) {
        return false;
    }

    const firstName = session.user.user_metadata?.first_name;
    return typeof firstName === 'string' && firstName.trim().length > 0;
}

/**
 * Get the user's first name from session metadata
 * @param session - The current Supabase session
 * @returns string | null - The user's first name or null if not set
 */
export function getUserFirstName(session: Session | null): string | null {
    if (!session?.user?.user_metadata?.first_name) {
        return null;
    }

    return session.user.user_metadata.first_name;
}

/**
 * Check if a user needs to complete their profile
 * @param session - The current Supabase session
 * @returns boolean - true if user needs to complete profile, false otherwise
 */
export function needsProfileCompletion(session: Session | null): boolean {
    // Only authenticated users with missing first names need profile completion
    if (!session?.user || session.user.is_anonymous) {
        return false;
    }

    return !isProfileComplete(session);
}
